var sectionsNavigation = document.querySelectorAll('.section-navigation');
if (sectionsNavigation !== null) {
  sectionsNavigation.forEach(sectionNavigation => {
    sectionNavigation.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        sectionNavigation.querySelectorAll('li').forEach(item => item.classList.remove('active'));
        anchor.parentNode.classList.add('active');
        sectionNavigation.querySelector('.grid').scrollLeft = anchor.parentNode.offsetLeft;
        document.querySelector(this.getAttribute("href")).parentNode.scrollIntoView({
          behavior: 'smooth'
        });
      });
    });

    setTimeout(function(){
      var sections = [];
      document.querySelectorAll('.shopify-section').forEach(shopifySection => {
        var sectionId = null;
        if (shopifySection.getElementsByTagName('div') !== null) {
          sectionId = shopifySection.getElementsByTagName('div')[0].getAttribute('id');
          if ((sectionId === '' || sectionId === null ) && shopifySection.querySelector('.jdgm-review-widget') !== null) {
            sectionId = shopifySection.querySelector('.jdgm-review-widget').getAttribute('id');
          }
          if (sectionId) {
            sections.push({
              name: sectionId,
              top: (shopifySection.offsetTop - 1),
              bottom: (shopifySection.offsetTop + shopifySection.getBoundingClientRect().height - 1)
            });
          }
        }
      });
      sections.forEach(function(value, index) {
        if (sections[index + 1] !== undefined) {
          sections[index]['bottom'] = (sections[index + 1]['top'] - 1);
        }
      });
      var isScrolling;
      document.addEventListener('scroll', function () {
        var currentScrollPositionY = (window.pageYOffset + 20);
        sections.forEach(section => {
          if (currentScrollPositionY >= section.top && currentScrollPositionY <= section.bottom ) {
            if (sectionNavigation.querySelector('a[href^="#' + section.name + '"]') !== null) {
              sectionNavigation.querySelectorAll('li').forEach(item => item.classList.remove('active'));
              sectionNavigation.querySelector('a[href^="#' + section.name + '"]').parentNode.classList.add("active");
              window.clearTimeout( isScrolling );
              isScrolling = setTimeout(function() {
                var anchor = document.querySelector('a[href^="#' + section.name + '"]');
                sectionNavigation.querySelector('.grid').scrollLeft = anchor.parentNode.offsetLeft;
              }, 66);
            }
          }
        });
      }, false);
    }, 2000);
  });
}